import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

$(function () {
  var pswpElement = document.querySelectorAll('.pswp')[0];

  var gallery;
  var items = [];
  var images = $('.product-single .zoom__img');

  if (!images.length) {
    return;
  }

  images.each(function () {
    var img = $(this);
    var aspectRatio = parseFloat(img.attr('data-aspectratio'));
    var zoomImg = img.attr('data-zoom-src');
    if (zoomImg) {
      items.push({
        src: zoomImg,
        w: 2000 * aspectRatio,
        h: 2000
      });

      img.on('click', function (e) {
        if (window.PREVENT_ZOOM) return;
        var index = images.index(this);

        var options = {
          index: index,
          zoomEl: true,
          shareEl: false,
          fullscreenEl: false,
          arrowKeys: false,
          counterEl: false,
          showHideOpacity: true,
          closeOnScroll: false
        };

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();

        // WORK AROUND to prevent background color error injected from Photoswipe in touchscreen devices.
        $('.pswp__top-bar').css('background', '#ffffff4d');
      });
    }
  });
});
